import React, { Component } from 'react';
import PubSub from 'pubsub-js'
import ReactPlayer from 'react-player'
import Controls from './Controls';
import Timeline from './Timeline';

class VideoWrapper extends Component {
    constructor(props) {
        super(props)
        this.state = {
            //   className: 'loading',
            //   videoIndex: 0,
            //   data: [],
            playing: true,
            muted: true,
            progress: null,
            //   status: 'init'
        }

        // this._prev = this._prev.bind(this)
        // this._next = this._next.bind(this)
    }

    componentDidMount() {
        
        PubSub.subscribe("MUTE", this._mute)
        PubSub.subscribe("TOGGLE", this._handlePlayPause)

        PubSub.subscribe("SEEK", this._seek)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data !== this.props.data) {
            //si pause/next test le playSate
            if(!this.state.playing)this._handlePlayPause()
        }
    }

    _handlePlayPause = () => {
        this.setState({ 
            playing: !this.state.playing 
        }, () => {
            // console.log("_handlePlayPause",this.state.playing)
            PubSub.publish("PLAYING", {playing: this.state.playing })
        })
        
    }

    _onDuration = (duration) => {
        console.log("_onDuration", duration)
        PubSub.publish("READY")
        // this.setState({ status: '' })
        this.setState({
            duration: duration
        })
    }
    _onReady = (event) => {
        this.setState({ status: 'ready' })
        // console.log("onReady",event)
        // console.log("onReady",this.refs.reactPlayer.getDuration())
        // this.setState({
        //   duration: this.refs.reactPlayer.getDuration()
        // })
    }
    _onStart = (event) => {
        console.log("onStart")
        PubSub.publish("START")
        // this.setState({
        //     className: ""
        // })
    }
    _onProgress = (progress) => {
        // console.log(event)
        // PubSub.publish("PROGRESS", {progress: progress})
        this.setState({
            progress: progress
        })
    }
    _onEnded = () => {
        // console.log('onEnded')
        // this._next()
        PubSub.publish("NEXT")
    }
    _onError = (e) => {
        console.log(e)
        // this._next()
        PubSub.publish("NEXT")
    }

    _mute = () => {
        // console.log(this.state.muted)
        this.setState({
            muted: !this.state.muted
        })
    }

    _seek = (e, d) => {
        const { duration } = this.state
        const newTime = (d.percent * duration) / 100
        // console.log(d.percent, duration, newTime)
        this.refs.reactPlayer.seekTo(newTime)
    }


    render() {
        const {
            status,
            videoIndex,
            videosLength,
            // data,
            className,
            muted,
            playing,
            progress,
            duration
        } = this.state
        // console.log(this.state)
        const { data, nextVideo } = this.props

// console.log(data)

        const config = {
            youtube: {
                playerVars: {
                    showinfo: 0,
                    iv_load_policy: 3,
                    cc_load_policy: 0,
                    modestbranding: 1,
                    showinfo: 0,
                    rel: 0,
                    origin: 'https://skate-tv.herokuapp.com/'
                }
            },
            vimeo: {
                title: false
            }
        }

        return (
            <div id="video-wrapper">
                <ReactPlayer
                    ref="reactPlayer"
                    className='react-player'
                    url={data.iframe}
                    width='100%'
                    height='100%'
                    playing={playing}
                    // controls
                    playsinline
                    config={config}
                    muted={muted}
                    onDuration={this._onDuration}
                    onReady={this._onReady}
                    onStart={this._onStart}
                    onProgress={this._onProgress}
                    onEnded={this._onEnded}
                    onError={this._onError}
                />

                <Controls playing={playing} muted={muted} />

                {progress &&
                    <Timeline 
                    progress={progress} 
                    duration={duration}
                    nextVideo={nextVideo} 
                    />
                }
        
            </div>
            

        );
    }
}

export default VideoWrapper;


// WEBPACK FOOTER //
// ./src/components/VideoWrapper.jsx